/**
 * Actor ids used by the harbor chapter. The two heroes and the 亚北 merchant use the characters
 * builder's ACTOR_DEFS keys directly (id === actor key), so timelines / dialogue speakers resolve to
 * the same sprite, display name and portrait everywhere. Environment NPCs are `gh-<short>` — the
 * manifest key convention (`actor-gh-<short>` cast sheets, tools/assets/README.md); see npcs.ts.
 */
export const ACTOR = {
  JIANG: 'jiang-zichao',
  ZHAO: 'zhao-chengbo',
  MERCHANT: 'yabei-merchant',
} as const;

/** Actor key of a harbor environment NPC from its data-local short name (`elder` → `gh-elder`). */
export const ghNpcId = (short: string): string => `gh-${short}`;

/** Display names for the dialogue box (speaker ids are stable; names are live Chinese text). */
export const DISPLAY_NAMES: Record<string, string> = {
  [ACTOR.JIANG]: '江子潮',
  [ACTOR.ZHAO]: '赵呈博',
  [ACTOR.MERCHANT]: '亚北商贩',
};

/** Real portrait texture keys (dev: copied from the dev portrait atlases when present). */
export const PORTRAIT_KEYS: Record<string, { key: string; devAtlas: string }> = {
  [ACTOR.JIANG]: { key: 'portrait-jiang-zichao', devAtlas: 'dev-portrait-hero' },
  [ACTOR.ZHAO]: { key: 'portrait-zhao-chengbo', devAtlas: 'dev-portrait-elder' },
  [ACTOR.MERCHANT]: { key: 'portrait-yabei-merchant', devAtlas: 'dev-portrait-merchant' },
};
